import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const DefaultReviewGroupsLoadable = Loadable({
  loading: LoadingPage,
  loader: () => import('./default-review-groups'),
});
